import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CreditCard, ArrowRight, Building, Shield, Clock } from "lucide-react";
import DashboardLayout from "@/components/DashboardLayout";

export default function BillPayPage({ user }) {
  return (
    <DashboardLayout user={user}>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-bold text-[#121212] font-['Manrope']">Bill Pay</h1>
          <Badge className="bg-[#BFFF00]/30 text-[#121212] rounded-full">Beta</Badge>
        </div>

        {/* Coming Soon Card */}
        <Card className="border-2 border-dashed border-[#BFFF00]/30 rounded-2xl">
          <CardContent className="py-16">
            <div className="text-center max-w-lg mx-auto">
              <div className="w-20 h-20 bg-[#F7FFE5] rounded-2xl flex items-center justify-center mx-auto mb-6 border-2 border-dashed border-[#BFFF00]">
                <CreditCard className="w-10 h-10 text-[#121212]" />
              </div>
              <h2 className="text-2xl font-bold text-[#121212] mb-3 font-['Manrope']">
                Pay Bills Automatically
              </h2>
              <p className="text-[#121212]/60 mb-8">
                Schedule and automate bill payments to vendors, contractors, and service providers. 
                Never miss a payment deadline again.
              </p>
              <Button className="bg-[#121212] hover:bg-[#2a2a2a] rounded-full px-8 font-semibold" data-testid="join-beta-btn">
                Join the Beta
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Feature Preview */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Card className="border-2 border-dashed border-gray-200 hover:border-[#BFFF00] hover:shadow-lg hover:shadow-[#BFFF00]/10 transition-all rounded-2xl group">
            <CardContent className="p-5">
              <div className="w-10 h-10 bg-[#F7FFE5] rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#BFFF00] transition-colors">
                <Building className="w-5 h-5 text-[#121212]" />
              </div>
              <h3 className="font-bold text-[#121212] mb-2 font-['Manrope']">ACH Transfers</h3>
              <p className="text-sm text-[#121212]/60">
                Free bank-to-bank transfers with same-day processing available.
              </p>
            </CardContent>
          </Card>
          <Card className="border-2 border-dashed border-gray-200 hover:border-[#BFFF00] hover:shadow-lg hover:shadow-[#BFFF00]/10 transition-all rounded-2xl group">
            <CardContent className="p-5">
              <div className="w-10 h-10 bg-[#F7FFE5] rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#BFFF00] transition-colors">
                <Clock className="w-5 h-5 text-[#121212]" />
              </div>
              <h3 className="font-bold text-[#121212] mb-2 font-['Manrope']">Scheduled Payments</h3>
              <p className="text-sm text-[#121212]/60">
                Set up recurring payments for rent, utilities, and subscriptions.
              </p>
            </CardContent>
          </Card>
          <Card className="border-2 border-dashed border-gray-200 hover:border-[#BFFF00] hover:shadow-lg hover:shadow-[#BFFF00]/10 transition-all rounded-2xl group">
            <CardContent className="p-5">
              <div className="w-10 h-10 bg-[#F7FFE5] rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#BFFF00] transition-colors">
                <Shield className="w-5 h-5 text-[#121212]" />
              </div>
              <h3 className="font-bold text-[#121212] mb-2 font-['Manrope']">Approval Workflows</h3>
              <p className="text-sm text-[#121212]/60">
                Set up approval rules for payments above certain thresholds.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </DashboardLayout>
  );
}
